import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip as RechartsTooltip, ResponsiveContainer,
} from 'recharts';

/** Horizontal bar chart grouping deliveries by an owner (Project Manager or Requestor). */
export const OwnerBreakdownChart = ({ title, data = [], onBarClick, color = '#3B82F6', testId }) => (
  <Card data-testid={testId}>
    <CardHeader className="pb-3">
      <CardTitle className="font-heading text-base">{title}</CardTitle>
      <CardDescription className="text-xs">Click a bar to view those deliveries</CardDescription>
    </CardHeader>
    <CardContent>
      {data.length > 0 ? (
        <ResponsiveContainer width="100%" height={Math.max(160, data.length * 32)}>
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 11 }} tickLine={false} allowDecimals={false} />
            <YAxis type="category" dataKey="name" tick={{ fontSize: 11 }} width={100} tickLine={false} />
            <RechartsTooltip
              cursor={{ fill: 'rgba(0,0,0,0.04)' }}
              content={({ active, payload, label }) => {
                if (!active || !payload?.length) return null;
                return (
                  <div className="bg-white border border-border rounded-lg shadow-lg px-3 py-2 text-sm">
                    <p className="font-semibold mb-1">{label}</p>
                    <p className="text-xs">Deliveries: <span className="font-medium">{payload[0].value}</span></p>
                  </div>
                );
              }}
            />
            <Bar
              dataKey="count"
              fill={color}
              radius={[0, 4, 4, 0]}
              className="cursor-pointer"
              onClick={(data) => { if (onBarClick) onBarClick(data?.payload || data); }}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-center text-muted-foreground py-4 text-sm">No data available</p>
      )}
    </CardContent>
  </Card>
);

export default OwnerBreakdownChart;
